module.exports = __webpack_public_path__ + "static/intelligents-tecnologis-10fdee080194dbf27f9383eb75f8ef83.png";